<template>
    <div class="download-container">
        <div class="download-title">
            <div>DOWNLOAD OUR APP</div>
            <div>TO GET MORE OUT OF YOUR VIDEO</div>
        </div>
        <div class="download-config">
            <div>
                <div class="icon">
                    <img src="../../../assets/img/path.svg" alt="path">
                </div>
                <label>CUT CLIPS</label>
            </div>
            <div>
                <div class="icon">
                    <img src="../../../assets/img/group-27.svg" alt="group">
                </div>
                <label>CUSTOM HIGHLIGHTS</label>
            </div>
        </div>
        <div class="download-buttons" v-if="platformName === 'any'">
            <div :key="banner.name" v-for="banner in banners">
                <Banner :key="banner.name" :banner="banner"/>
            </div>
        </div>
        <div class="download-buttons" v-else>
            <Banner :banner="banners.find(item => item.name === platformName)" />
        </div>
    </div>
</template>

<script>
import Banner from '../../components/Banner';
import globals from '../../helpers/constants';
import helper from '../../helpers/helper';

export default {
    name: 'DownloadApp',
    components: {
        Banner
    },
    data() {
        return {
            banners: globals.banners
        }
    },
    computed: {
        platformName() {
            return helper.platformName();
        }
    }
}
</script>
